import React from 'react';
import { IconProps } from '.';

const SvgColoredFingerTwo = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <g clipPath='url(#ColoredFingerTwo_svg__a)'>
        <path
          fill='#EC8A3C'
          d='M18.49 11.69c-.18-.18-.4-.34-.63-.46l-.29-.98-5.81-.04-.22.79c-.34.07-.75.28-1.01.52L7.91 8.65c-.59.26-1.01.86-1.01 1.55v.7L4 13.91v1.59l7.25 7.78s7.62-11.08 7.64-11.06c-.09-.16-.37-.51-.4-.53Z'
        />
        <path
          fill='#FFD653'
          d='M16.74 10.95h-4.77c-.15 0-.3.02-.44.04l-.05-.2-2.37-9.03S8.81.34 10.22.04c1.42-.3 1.72 1.12 1.72 1.12l2.24 8.39c.32.02.64.05.95.08l1.49-7.62S16.76.57 18.2.7c1.44.14 1.31 1.58 1.31 1.58l-1.5 8.09-.16.87c-.34-.17-.71-.28-1.11-.28v-.01ZM5.39 9.5h.12c.77 0 1.39.62 1.39 1.39v3.02c0 .77-.62 1.39-1.39 1.39h-.12c-.77 0-1.39-.62-1.39-1.39v-3.02c0-.77.62-1.39 1.39-1.39Zm5.01 2.15-.04.04c-.34.38-.56.88-.56 1.43 0 .05 0 .09.01.13.03.49.22.94.53 1.29-.05.09-.12.18-.19.26-.27.3-.65.5-1.08.5-.8 0-1.45-.65-1.45-1.45V9.5c0-.32.11-.61.28-.85.26-.36.69-.6 1.17-.6.8 0 1.45.65 1.45 1.45v2.01s-.08.09-.12.13v.01Z'
        />
        <path
          fill='#FFD653'
          d='M5.49 16.03c.74 0 1.4-.38 1.78-.96.09.13.2.25.31.36.86.81 2.2.76 3.02-.06.11-.11.22-.22.3-.35.15.08.34.29 1.07.29h1.84c-.27.2-.51.45-.74.72-.89 1.06-1.46 2.61-1.46 4.35 0 .2.16.36.36.36.2 0 .36-.16.36-.36 0-1.85.69-3.46 1.72-4.35.53-.46 1.15-.72 1.81-.72.52.06.61-.72.09-.72h-3.99a1.451 1.451 0 0 1 0-2.9h5.8c.62 0 1.2.43 1.39 1.03l.79 2.6c.07.24.35 1.36.3 1.59 0 3.49-3.4 7.11-7.55 7.11-4.73-.02-8.58-3.81-8.68-8.53h.01c.37.33.85.53 1.38.53h.09v.01Z'
        />
      </g>
      <defs>
        <clipPath id='ColoredFingerTwo_svg__a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgColoredFingerTwo;
